import { render, staticRenderFns } from "./LearningSession.vue?vue&type=template&id=0f012a42&scoped=true&"
import script from "./LearningSession.vue?vue&type=script&lang=js&"
export * from "./LearningSession.vue?vue&type=script&lang=js&"
import style0 from "./LearningSession.vue?vue&type=style&index=0&id=0f012a42&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f012a42",
  null
  
)

export default component.exports